import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '@/lib/route-guards';
import { SystemHealthView } from '@/screens/system-health';

export const Route = createFileRoute('/backend/system-health')({
  // Route-data exemption: realtime. Both reads poll, and blocking first paint on a number that
  // will arrive again in thirty seconds buys nothing.
  beforeLoad: requireSession,
  component: SystemHealthView,
});
